import { observable } from "mobx";
import { Type } from "class-transformer";
import DecimalRangeRequest from "./decimalRangeRequest";
import RefundApprovalType from "./refundApprovalType";
import CounterpartyBankAccountRequest from "./counterpartyBankAccountRequest";
import TransferPaymentType from "./transferPaymentType";
import type { EntityValidationRules } from "../services/validationService";
import { RefundsSearchFilterValidationRules } from "./filters/refunds/refundsSearchFilter";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class TransferRefundsRequest {
  /**
   * Number of records to be selected.
   * @example
   * 20
   */
  @observable
  limit?: number;

  @observable
  offset?: number;

  @observable
  fullTextSearchEnabled?: boolean;

  @observable
  refundPaymentTemplateId?: string;

  @observable
  @Type(() => DecimalRangeRequest)
  refundAmount?: DecimalRangeRequest;

  @observable
  approvedBy?: RefundApprovalType;

  @observable
  notApprovedBy?: RefundApprovalType;

  @observable
  officialRecordId?: string;

  @observable
  transferType!: TransferPaymentType;

  @observable
  countryId?: string;

  @observable
  licensePlate?: string;

  @observable
  @Type(() => CounterpartyBankAccountRequest)
  senderBankAccount?: CounterpartyBankAccountRequest;

  @observable
  variableSymbol?: number;

  @observable
  paidAmount?: number;

  @observable
  @Type(() => Date)
  postingDate?: Date;
}

export const TransferRefundsRequestValidationRules: EntityValidationRules<TransferRefundsRequest> = {
  ...RefundsSearchFilterValidationRules,
};
